module.exports = __webpack_public_path__ + "img/vocieType.d413cb5e.png";